import { InjectionToken, Type } from '@angular/core';

export type LazyModulesProvider = () => Promise<Type<any>>;
export const LAZY_MODULES = new InjectionToken<{ [key: string]: string }>('LAZY_MODULES');
